import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import { newOperatorRequest } from 'modules/operators/actions';
import { GetOperatorFields } from 'modules/operators/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { useHistory } from 'react-router';
import FormOperator from '../Form';
import styles from './styles';
import { initialEdit } from '../Form/initialValues';

const useStyles = makeStyles(styles);

interface Props {
  newOperatorRequest: (values: GetOperatorFields) => void;
  isLoading: boolean;
}

const NewOperator = ({ newOperatorRequest, isLoading }: Props) => {
  const handleSubmit = (values: GetOperatorFields) => {
    newOperatorRequest(values);
  };
  const history = useHistory();

  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageTitle
          title={i18n.t('OPERATORS_PAGE.ADD_OPERATOR_TITLE_KEY')}
          iconTitle={
            <Tooltip
              className={classes.tooltipTitle}
              placement="right"
              arrow
              title={i18n.t('OPERATORS_PAGE.ADD_OPERATOR_TOOLTIP_KEY')}
            >
              <InfoIcon fontSize="small" color="action" />
            </Tooltip>
          }
          subtitle={i18n.t('OPERATORS_PAGE.ADD_OPERATOR_SUBTITLE_KEY')}
        />
      </Grid>

      <FormOperator
        initialValues={initialEdit}
        onCancel={() => history.push('/operators')}
        isLoading={isLoading}
        onSubmit={handleSubmit}
      />
    </Grid>
  );
};

const mapStateToProps = ({ operators: { isLoading } }: ApplicationState) => ({
  isLoading,
});

export default connect(mapStateToProps, {
  newOperatorRequest,
})(NewOperator);
